import { I18nService } from '@/core/services/i18nService';
import { PaymentDisplayModel, AnfrageDisplayModel, PaymentFoerdersummenDisplayModel, GlobalEnumsAceMittelabruf, LocalizedTextDisplayModel } from '@/api/model-index';
import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { PortalkonfigurationDisplayModel } from '../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { NavigationItem } from '@/core/models/navigation-item.model';
import { NavigationService } from '@/core/services/navigation.service';
import { PaymentService } from '@/core/services/payment.service';

@Component({
    selector: 'app-anfrage-fund-funding-amount',
    templateUrl: './funding-amount.component.html',
    styleUrls: ['./funding-amount.component.scss']
})
export class FundingAmountComponent {
    public anfrage: AnfrageDisplayModel;
    public fundingAmounts: PaymentFoerdersummenDisplayModel;
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    public navItem: NavigationItem | null;
    public type: GlobalEnumsAceMittelabruf = GlobalEnumsAceMittelabruf.Forderbetrag;

    public get payments(): PaymentDisplayModel[]
    {
        if (this.paymentService.payments.length > 0)
            return this.paymentService.payments;

        return [];
    }

    constructor(protected route: ActivatedRoute,
        protected languageservice: I18nService,
        protected navigationService: NavigationService,
        protected paymentService: PaymentService
        ) {
        
        this.anfrage = this.route.snapshot.data.anfrage;
        this.fundingAmounts = this.route.snapshot.data.fundingAmounts;
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;

        if (this.portalkonfiguration.mittelabrufAbschnitt)
            this.navItem = this.navigationService.getNavItem(this.portalkonfiguration.mittelabrufAbschnitt)
    }

    public get abschnittInfotext(): string {
        let infotext: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.mittelabrufAbschnitt?.infotext);
        return infotext?.text ?? "";
    }
}
